import React, { useEffect, useMemo, useState } from "react";
import { clearPerformanceTimings, getPerformanceTimingSamples, PERFORMANCE_TIMING_EVENT, PerformanceTimingDetail, summarizePerformanceTimings } from "../../utilities/performanceMetrics";

export const isPerformanceDiagnosticsEnabled = (
  search: string,
  environment = process.env.NODE_ENV,
) => environment !== "production" && new URLSearchParams(search).get("performanceDiagnostics") === "1";

const PerformanceDiagnosticsPanel = () => {
  const enabled = useMemo(() => typeof window !== "undefined" && isPerformanceDiagnosticsEnabled(window.location.search), []);
  const [samples, setSamples] = useState<PerformanceTimingDetail[]>(getPerformanceTimingSamples());
  useEffect(() => {
    if (!enabled) return;
    const update = () => setSamples(getPerformanceTimingSamples());
    window.addEventListener(PERFORMANCE_TIMING_EVENT, update);
    return () => window.removeEventListener(PERFORMANCE_TIMING_EVENT, update);
  }, [enabled]);
  if (!enabled) return null;
  return (
    <aside aria-label="Performance diagnostics" style={{ position: "fixed", right: 8, bottom: 8, zIndex: 100000, width: 390, maxHeight: "45vh", overflow: "auto", background: "#111", color: "#fff", padding: 12, fontSize: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}><strong>Performance diagnostics</strong><button type="button" onClick={() => { clearPerformanceTimings(); setSamples([]); }}>Clear</button></div>
      <table style={{ width: "100%" }}><thead><tr><th align="left">Phase</th><th>n</th><th>p50</th><th>p95</th><th>fail</th></tr></thead>
        <tbody>{summarizePerformanceTimings(samples).map((item) => <tr key={item.name}><td>{item.name}</td><td align="right">{item.count}</td><td align="right">{item.p50Ms.toFixed(1)}</td><td align="right">{item.p95Ms.toFixed(1)}</td><td align="right">{item.failures}</td></tr>)}</tbody>
      </table>
    </aside>
  );
};
export default PerformanceDiagnosticsPanel;
